define('views/parts/list/list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'sortable', 'utils',
], function(
    // Libs
    _, Backbone, Mustache, Sortable, U
) {

    /**
     * Encapsulate the rendering of a list view.
     *
     * Offers the following properties:
     *
     * @property {Object} sortable - drag'n'drop options, can be overriden when passing it as an option.
     * @property {Backbone.View} item - the item view constructor to use.
     */
    var VList = Backbone.Epoxy.View.extend({

        constructor: function(opt) {
            opt = this.options = _.extend({
                prepend: false,
            }, opt);

            if (opt.item) {
                this.item = opt.item;
            }

            if (opt.sortable !== false && (opt.sortable || this.sortable)) {
                this.sortable = _.extend({
                    context: this
                }, this.sortable, opt.sortable);
            }

            VList.__super__.constructor.call(this, opt);

            // listeners
            this.listenTo(this.collection, {
                'reset': this.resetList,
                'update': this.onUpdate,
            });
        },

        render: function() {
            var $el = this.$el.empty(),
                options = this.options,
                template = this.template;

            if (template) $el.append(Mustache.render(template, Mustache.getContext(options)));

            this.applyBindings();
            this.generateZones();

            var zone = this.zone,
                $list = zone.$list || (zone.$list = $el),
                isSortable = options.sortable !== false && this.sortable;

            if (isSortable) this._initSortable($list);
            $list.toggleClass('sortable', isSortable);

            this.resetList();
            return this;
        },

        renderAll: function(models) {
            var thisCollection = this.collection,
                collection = models || thisCollection.models,
                container = document.createDocumentFragment(),
                count = 0,
                delay = 50,
                prepend = this.options.prepend ||
                !thisCollection.isEmpty() &&
                thisCollection.first().is(_.first(collection));

            _.each(collection, function(model) {
                var viewElement = this.renderOne(model, 1 + delay * count++, false).el;
                if (prepend) {
                    container.insertBefore(viewElement, container.firstchild);
                } else {
                    container.appendChild(viewElement);
                }
            }, this);

            this.zone.$list[prepend ? 'prepend' : 'append'](container);

            this.onAfterListRender();

            return this;
        },

        renderOne: function(model, delay, render) {
            var options = this.getItemOptions({
                    model: model,
                    selected: this.selected,
                }),
                view = new this.item(options);

            this.childViews.push(view);
            view.render(delay);

            if (render !== false) this.zone.$list.append(view.el);

            return view;
        },

        resetList: function() {
            var zone = this.zone;
            if (!zone || !zone.$list) return;
            zone.$list.empty();
            this.onListEmpty();
            this.removeChildViews({ defer: true })
                .renderAll();
        },

        children: function() {
            return this.zone.$list.children();
        },

        _initSortable: function($elem) {
            this.sortableElem = Sortable.create($elem, this.sortable);
        },

        getItemOptions: _.identity,

        ////////////
        // events //
        ////////////
        onUpdate: function(collection, options) {
            var added = options.changes.added;
            if (added && added.length > 0) {
                var comparator = collection.comparator;
                if (comparator) added = _.sortBy(added, function(model) { return model.get(comparator); });
                this.renderAll(added);
            }
        },

        onLoadMore: function(e, callback) {
            this.collection.getNextPage({ fetch: true }).always(callback);
        },

        onListEmpty: _.noop,
        onAfterListRender: _.noop,

    });

    return VList;

});

